import { render, staticRenderFns } from "./formsdata.vue?vue&type=template&id=58ffb3f8&scoped=true"
import script from "./formsdata.vue?vue&type=script&lang=js"
export * from "./formsdata.vue?vue&type=script&lang=js"
import style0 from "./formsdata.vue?vue&type=style&index=0&id=58ffb3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffb3f8",
  null
  
)

export default component.exports